import { render } from "./g-catalog-order_list.vue?vue&type=template&id=d8f4fb7e&ts=true"
import script from "./g-catalog-order_list.vue?vue&type=script&lang=tsx"
export * from "./g-catalog-order_list.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__